import React from 'react';
import { AsyncPaginate, LoadOptions } from 'react-select-async-paginate';

import { OptionType } from '../../utils/interface';

interface SearchableDropdownProps {
  placeholder?: string;
  onChange: (selectedOption: OptionType) => void;
  selectedData: OptionType | null;
  isDisabled?: boolean;
  fetchData: (searchTerm: string, pageIndex: number, pageSize: number) =>
    Promise<{ options: OptionType[], hasMore: boolean }>;
}

const SearchableDropdown: React.FC<SearchableDropdownProps> = ({
  placeholder = "",
  fetchData,
  onChange,
  selectedData,
  isDisabled = false,
}) => {

  const loadOptions: LoadOptions<OptionType, any, { page: number }> = async (
    inputValue,
    loadedOptions
  ) => {
    try {
      const pageSize = 10
      const pageIndex = loadedOptions.length / pageSize;
      const response = await fetchData(inputValue, pageIndex, pageSize);
      return response;
    } catch (error) {
      console.error('Error loading options:', error);
      return {
        options: [],
        hasMore: false,
      };
    }
  };

  return (
    <AsyncPaginate
      loadOptions={loadOptions}
      {...(selectedData ? { value: selectedData } : {})}
      onChange={(selectedOption: OptionType | null) => {
        if (selectedOption) {
          onChange(selectedOption)
        }
      }
      }
      placeholder={placeholder}
      additional={{
        page: 1,
      }}
      isDisabled={isDisabled}
    />
  );
};

export default SearchableDropdown;
